import AOS from 'aos';

const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function refreshAnimations() {
	AOS.refreshHard();
}

export default function initAnimations() {
	if (motionQuery.matches) {
		return;
	}

	AOS.init({
		anchorPlacement: 'top-bottom',
		duration: 400,
		easing: 'ease-out-cubic',
		once: true,
		offset: 35,
	});

	requestAnimationFrame(refreshAnimations);

	window.addEventListener('load', refreshAnimations, { once: true });

	if (document.fonts?.ready) {
		document.fonts.ready.then(refreshAnimations).catch(() => {});
	}
}
